module.exports = __webpack_public_path__ + "img/sliders-alt-vertical.97ab1e0a.svg";